/* Configurable Micasa module; safe to re-render in the Shopify editor. */
window.MicasaInit.register("seasonal",scope=>{
'use strict';
const tx=value=>window.MicasaText(value);


'use strict';
const THEMES=['halloween','blackfriday','christmas','everyday'];
const MODES=['auto',...THEMES];
const STORAGE_KEY='micasa-seasonal-theme-'+(window.MicasaConfig?.themeId||'draft');
const INTERVAL=Math.max(2000,Number(document.querySelector('#seasonal-carousel')?.dataset.interval)||7000);
const heroConfig=window.MicasaSectionConfig('home-hero');
const params=new URLSearchParams(location.search);
const designMode=window.MicasaConfig?.designMode===true;
function saveMode(value){if(designMode)return;try{if(value==='auto')localStorage.removeItem(STORAGE_KEY);else localStorage.setItem(STORAGE_KEY,value)}catch{}}
function dateParts(value=new Date()){
 const date=value instanceof Date?value:new Date(value);
 if(!Number.isFinite(date.getTime()))return dateParts(new Date());
 const parts=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Rome',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(date);
 const number=type=>Number(parts.find(p=>p.type===type)?.value);
 return {year:number('year'),month:number('month'),day:number('day')};
}
function calendarTheme(value=new Date()){
 const {month,day}=dateParts(value);
 if(month===10)return 'halloween';
 if(month===11)return 'blackfriday';
 if(month===12&&day<=26)return 'christmas';
 return 'everyday';
}
function blackFridayDay(year){const first=new Date(Date.UTC(year,10,1)).getUTCDay();return 1+(5-first+7)%7+21}
const queryMode=params.get('theme');
const configuredMode=MODES.includes(window.MicasaConfig?.seasonMode)?window.MicasaConfig.seasonMode:'auto';
// A matching editor stamp means this URL came from navigation under the current
// saved setting. A changed setting invalidates older preview URL overrides.
const acceptsQuery=!designMode||params.get('micasa_season_setting')===configuredMode;
let mode=acceptsQuery&&MODES.includes(queryMode)?queryMode:configuredMode;
let calendarBase=calendarTheme();
let theme=mode==='auto'?calendarBase:mode;
if(!designMode&&MODES.includes(queryMode))saveMode(mode);
const carousel=document.querySelector('#seasonal-carousel');
const viewport=carousel?.querySelector('[data-season-viewport]');
const slides=carousel?[...carousel.querySelectorAll('[data-season-slide]')]:[];
const tabs=carousel?[...carousel.querySelectorAll('[data-season-target]')]:[];
const labels=Object.fromEntries(slides.map(slide=>[slide.dataset.seasonSlide,heroConfig.labels?.[slide.dataset.seasonSlide]??slide.getAttribute('aria-label')??'']));
const keyboardLabel=heroConfig.keyboard_label??viewport?.getAttribute('aria-label')??'';
const controls=carousel?.querySelector('[data-season-controls]');
const playButton=carousel?.querySelector('[data-season-play]');
const status=carousel?.querySelector('[data-season-status]');
const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
const canHover=window.matchMedia('(hover: hover)');
let eligible=[];
let activeSlide='';
let timer=null;
let userPaused=motion.matches||carousel?.dataset.autoplay==='false';
let hoverPaused=false;
let focusPaused=false;
let inView=true;
let allowFocusedPlayback=false;
let themeBar=document.getElementById('seasonal-atmosphere');

function decorateHref(href,selectedTheme=theme){return window.MicasaRoute(href,selectedTheme)}
function url(href){return decorateHref(href,theme)}
function decorateLinks(root=document){
 const anchors=root instanceof Element&&root.matches('a[href]')?[root]:[];
 if(root.querySelectorAll)anchors.push(...root.querySelectorAll('a[href]'));
 anchors.forEach(anchor=>{const old=anchor.getAttribute('href');const explicit=anchor.dataset.seasonLink;const next=decorateHref(old,THEMES.includes(explicit)?explicit:theme);if(next!==old)anchor.setAttribute('href',next)});
}
function updateBar(){
 if(!themeBar){
  const header=document.querySelector('header.header');
  if(!header)return;
  themeBar=document.createElement('aside');themeBar.className='season-bar';themeBar.id='seasonal-atmosphere';themeBar.setAttribute('aria-label',tx('Idee della stagione'));
  header.insertAdjacentElement('afterend',themeBar);
 }
 themeBar.setAttribute('aria-label',tx('Idee della stagione'));
 themeBar.hidden=theme==='everyday';
 const content={
  halloween:{label:tx('Halloween 2026'),text:window.MicasaHalloweenCampaign?.isActive()?tx('Costumi, decorazioni e idee per la festa.'):tx('Iniziativa conclusa il 31 ottobre 2026.'),link:window.MicasaHalloweenCampaign?.isActive()?tx('Scopri l’iniziativa'):tx('Leggi l’archivio'),href:'/pages/custom-category?view=micasa-halloween'},
  blackfriday:{label:tx('Black Friday'),text:tx('Le novità partono dal tuo negozio.'),link:tx('Trova il tuo Micasa'),href:'/pages/all-stores'},
  christmas:{label:tx('Natale'),text:window.MicasaChristmasCampaign?.isEnabled()?tx('Scopri l’iniziativa di Natale da Micasa.'):tx('Un mondo di idee da scoprire in negozio.'),link:window.MicasaChristmasCampaign?.isEnabled()?tx('Scopri l’iniziativa'):tx('Esplora i reparti'),href:window.MicasaChristmasCampaign?.isEnabled()?'/pages/custom-category?view=micasa-christmas':'/pages/custom-category?view=micasa-categories'},
  everyday:{label:tx('Micasa'),text:tx('Casa, persona e tempo libero.'),link:tx('Scopri i reparti'),href:'/pages/custom-category?view=micasa-categories'}
 }[theme];
 const shared=window.MicasaData.seasons[theme],campaignActive=theme==='halloween'?window.MicasaHalloweenCampaign?.isActive():theme==='christmas'?window.MicasaChristmasCampaign?.isEnabled():true;
 if(shared){content.label=tx(shared.bar_label??content.label);content.text=tx((campaignActive?shared.bar_text:shared.bar_text_inactive)??content.text);content.link=tx((campaignActive?shared.bar_button:shared.bar_button_inactive)??content.link);content.href=(campaignActive?shared.bar_url:shared.bar_url_inactive)??content.href;}
 themeBar.innerHTML=window.MicasaTextHTML('<div class="wrap"><span class="season-bar-mark" aria-hidden="true"></span><strong>'+content.label+'</strong><span class="season-bar-copy">'+content.text+'</span><a '+(content.href?'href="'+url(content.href)+'"':'aria-disabled="true"')+'>'+content.link+' <svg aria-hidden="true"><use href="#i-arrow"/></svg></a></div>',themeBar);
}
function updateCalendarCopy(){
 if(!carousel)return;
 const {month,day,year}=dateParts();
 const friday=blackFridayDay(year);
 const bfTitle=carousel.querySelector('[data-season-bf-title]');
 const bfBadge=carousel.querySelector('[data-season-bf-badge]');
 if(bfTitle&&!bfTitle.dataset.customCopy)bfTitle.innerHTML=window.MicasaTextHTML(month<11||(month===11&&day<friday)?'IL BLACK FRIDAY<br>SI AVVICINA.':(month===11&&day===friday?'È IL MOMENTO<br>DEL BLACK FRIDAY.':'LE IDEE DEL<br>BLACK FRIDAY.'),bfTitle);
 if(bfBadge&&!bfBadge.dataset.customCopy)bfBadge.textContent=month<11||(month===11&&day<friday)?tx('IN ARRIVO'):tx('IL TUO NEGOZIO');
}
function stopTimer(){if(timer!==null){clearTimeout(timer);timer=null}}
function shouldPlay(){return Boolean(carousel&&eligible.length>1&&!userPaused&&!hoverPaused&&!focusPaused&&inView&&document.visibilityState!=='hidden')}
function updatePlayButton(){
 if(!playButton)return;
 const paused=userPaused;
 playButton.replaceChildren();const playIcon=document.createElement('span');playIcon.setAttribute('aria-hidden','true');playIcon.textContent=paused?'▷':'Ⅱ';playButton.append(playIcon,document.createTextNode(' '+(paused?(heroConfig.play??tx('Riproduci')):(heroConfig.pause??tx('Pausa')))));
 playButton.setAttribute('aria-pressed',String(paused));
 playButton.setAttribute('aria-label',paused?(heroConfig.play??tx('Riproduci il carosello')):(heroConfig.pause??tx('Metti in pausa il carosello')));
 carousel.dataset.seasonPlaying=String(shouldPlay());
}
function syncTimer(){
 stopTimer();updatePlayButton();
 if(shouldPlay())timer=scope.timeout.bind(scope)(()=>{timer=null;const index=eligible.indexOf(activeSlide);showSlide(eligible[(index+1)%eligible.length],{manual:false})},INTERVAL);
}
function setPaused(paused){userPaused=Boolean(paused);if(!paused){allowFocusedPlayback=true;focusPaused=false}syncTimer()}
function renderAtmosphere(next,{history=true}={}){
 theme=next;
 document.body.dataset.season=theme;document.body.dataset.seasonMode=mode;
 if(history){try{const current=new URL(location.href);current.searchParams.set('theme',theme);if(designMode)current.searchParams.set('micasa_season_setting',configuredMode);window.history.replaceState(null,'',current.href)}catch{}}
 updateBar();updateCalendarCopy();decorateLinks();
 window.dispatchEvent(new CustomEvent('micasa:seasonchange',{detail:{theme,mode}}));
}
function showSlide(next,{manual=true,history=true}={}){
 if(!carousel||!eligible.includes(next))return false;
 if(manual){userPaused=true;allowFocusedPlayback=false}
 const previous=slides.find(slide=>slide.dataset.seasonSlide===activeSlide);
 if(previous&&previous!==slides.find(slide=>slide.dataset.seasonSlide===next)&&previous.contains(document.activeElement))viewport?.focus({preventScroll:true});
 activeSlide=next;
 slides.forEach(slide=>{
  const selected=slide.dataset.seasonSlide===next;
  slide.hidden=!selected;slide.inert=!selected;
  slide.setAttribute('aria-hidden',String(!selected));
  if(selected)slide.setAttribute('aria-label',(eligible.indexOf(next)+1)+tx(' di ')+eligible.length+' · '+labels[next]);
 });
 tabs.forEach(tab=>tab.setAttribute('aria-pressed',String(tab.dataset.seasonTarget===next)));
 if(status){status.setAttribute('aria-live',manual?'polite':'off');status.textContent=String(eligible.indexOf(next)+1).padStart(2,'0')+' / '+String(eligible.length).padStart(2,'0')}
 carousel.dataset.activeSeasonSlide=next;
 renderAtmosphere(THEMES.includes(next)?next:theme,{history});
 syncTimer();
 window.dispatchEvent(new CustomEvent('micasa:slidechange',{detail:{theme:next,index:eligible.indexOf(next),manual}}));
 return true;
}
function applyTheme(next,{persist=true,history=true,manual=true}={}){
 mode=MODES.includes(next)?next:'auto';calendarBase=calendarTheme();
 let nextTheme=mode==='auto'?calendarBase:mode;
 if(persist)saveMode(mode);
 if(carousel){
  const available=slides.map(slide=>slide.dataset.seasonSlide),promotions=available.filter(key=>!THEMES.includes(key)),seasonalSlides=available.filter(key=>key!=='everyday');eligible=nextTheme==='everyday'&&available.includes('everyday')?['everyday',...promotions]:seasonalSlides.length?seasonalSlides:available.filter(key=>key==='everyday');carousel.hidden=available.length===0;if(!eligible.length){if(controls)controls.hidden=true;renderAtmosphere(nextTheme,{history});syncTimer();return theme}if(!eligible.includes(nextTheme))nextTheme=eligible[0];
  if(controls)controls.hidden=eligible.length<2;
  if(viewport)viewport.setAttribute('aria-label',keyboardLabel);
  showSlide(nextTheme,{manual,history});
 }else{renderAtmosphere(nextTheme,{history});syncTimer()}
 return theme;
}

if(carousel){
 tabs.forEach(tab=>scope.on.bind(scope,tab)('click',()=>THEMES.includes(tab.dataset.seasonTarget)?applyTheme(tab.dataset.seasonTarget):showSlide(tab.dataset.seasonTarget)));
 scope.on.bind(scope,carousel.querySelector('[data-season-prev]'))('click',()=>{const index=eligible.indexOf(activeSlide);showSlide(eligible[(index-1+eligible.length)%eligible.length])});
 scope.on.bind(scope,carousel.querySelector('[data-season-next]'))('click',()=>{const index=eligible.indexOf(activeSlide);showSlide(eligible[(index+1)%eligible.length])});
 scope.on.bind(scope,playButton)('click',()=>setPaused(!userPaused));
 scope.on.bind(scope,carousel)('mouseenter',()=>{if(canHover.matches){hoverPaused=true;syncTimer()}});
 scope.on.bind(scope,carousel)('mouseleave',()=>{hoverPaused=false;syncTimer()});
 scope.on.bind(scope,carousel)('focusin',event=>{focusPaused=!(event.target===playButton&&allowFocusedPlayback);if(event.target!==playButton)allowFocusedPlayback=false;syncTimer()});
 scope.on.bind(scope,carousel)('focusout',event=>{if(!carousel.contains(event.relatedTarget)){focusPaused=false;allowFocusedPlayback=false;syncTimer()}});
 scope.on.bind(scope,carousel)('keydown',event=>{
  if(event.altKey||event.ctrlKey||event.metaKey||event.target.matches('input,textarea,select'))return;
  const index=eligible.indexOf(activeSlide);let target;
  if(event.key==='ArrowRight')target=eligible[(index+1)%eligible.length];
  if(event.key==='ArrowLeft')target=eligible[(index-1+eligible.length)%eligible.length];
  if(event.key==='Home')target=eligible[0];
  if(event.key==='End')target=eligible[eligible.length-1];
  if(target){event.preventDefault();showSlide(target)}
 });
 let pointer=null,lastSwipe=0;
 scope.on.bind(scope,viewport)('pointerdown',event=>{if(event.isPrimary!==false&&(event.pointerType==='touch'||event.pointerType==='pen'))pointer={x:event.clientX,y:event.clientY,id:event.pointerId}},{passive:true});
 scope.on.bind(scope,viewport)('pointerup',event=>{
  if(!pointer||event.pointerId!==pointer.id)return;
  const dx=event.clientX-pointer.x,dy=event.clientY-pointer.y;pointer=null;
  if(eligible.length>1&&Math.abs(dx)>48&&Math.abs(dx)>Math.abs(dy)*1.3){event.preventDefault();lastSwipe=Date.now();const index=eligible.indexOf(activeSlide);showSlide(eligible[(index+(dx<0?1:-1)+eligible.length)%eligible.length])}
 });
 scope.on.bind(scope,viewport)('pointercancel',()=>{pointer=null});
 scope.on.bind(scope,viewport)('click',event=>{if(Date.now()-lastSwipe<500){event.preventDefault();event.stopImmediatePropagation()}},true);
 if('IntersectionObserver' in window){scope.observer(IntersectionObserver,entries=>{inView=entries[0].isIntersecting&&entries[0].intersectionRatio>.2;syncTimer()},{threshold:[0,.2,.5]}).observe(carousel)}
 scope.on.bind(scope,motion)('change',event=>{if(event.matches)userPaused=true;syncTimer()});
}
scope.on.bind(scope,window)('micasa:christmascampaignchange',()=>{if(theme==='christmas')updateBar()});
scope.on.bind(scope,window)('micasa:halloweencampaignchange',()=>{if(theme==='halloween')updateBar()});
scope.on.bind(scope,document)('visibilitychange',()=>{
 if(document.visibilityState!=='hidden'&&mode==='auto'&&calendarTheme()!==calendarBase)applyTheme('auto',{persist:false,history:false,manual:false});
 syncTimer();
});
scope.on.bind(scope,document)('click',event=>{
 const link=event.target.closest('a[data-season-link]');
 if(link&&THEMES.includes(link.dataset.seasonLink))saveMode(link.dataset.seasonLink);
},true);
// Retire rejected editor overrides immediately. Otherwise an A→B→A settings
// change could make an old A stamp valid again and revive its stale slide.
applyTheme(mode,{persist:false,history:designMode&&(!acceptsQuery||!MODES.includes(queryMode)),manual:false});
const firstPromotion=slides.find(slide=>slide.hasAttribute('data-promotion-slide'));
if(firstPromotion&&heroConfig.promotion_first)showSlide(firstPromotion.dataset.seasonSlide,{manual:false,history:false});
scope.observer(MutationObserver,records=>{
 records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===Node.ELEMENT_NODE)decorateLinks(node)}));
}).observe(document.body,{childList:true,subtree:true});
window.MicasaSeasonal={
 url,
 setTheme:(next,options)=>applyTheme(next,options),
 calendarTheme,
 showSlide:(next,options)=>showSlide(next,options),
 play:()=>setPaused(false),pause:()=>setPaused(true),
 getState:()=>({mode,theme,activeSlide,eligible:[...eligible],playing:shouldPlay(),userPaused,hoverPaused,focusPaused,inView,interval:INTERVAL})
};


});


/* Homepage promotion dialogs reuse the carousel poster; one automatic view per session. */
window.MicasaInit.register('hero-promotion-popup',scope=>{
 'use strict';
 const root=document.querySelector('[data-micasa-module="mc-home-hero"]');
 if(!root)return;
 const config=window.MicasaSectionConfig('home-hero');
 const dialogs=[...root.querySelectorAll('[data-hero-promo-dialog]')];
 if(!config.promotion_popup_enabled||!dialogs.length)return;
 let opener=null,bodyOverflow=null,resume=false;
 const key=dialog=>'micasa-hero-promotion-'+(window.MicasaConfig?.themeId||'live')+'-'+dialog.dataset.heroPromoDialog+'-'+(dialog.querySelector('img')?.getAttribute('src')||'');
 const seen=dialog=>{try{return sessionStorage.getItem(key(dialog))==='1'}catch{return false}};
 const markSeen=dialog=>{try{sessionStorage.setItem(key(dialog),'1')}catch{}};
 function restore(){
  if(bodyOverflow!==null){document.body.style.overflow=bodyOverflow;bodyOverflow=null}
  if(opener?.isConnected)opener.focus({preventScroll:true});opener=null;
  if(resume)window.MicasaSeasonal?.play();resume=false;
 }
 function open(dialog,trigger){
  if(!scope.active||dialog.open||!dialog.isConnected||typeof dialog.showModal!=='function')return;
  if(dialogs.some(item=>item.open))return;
  opener=trigger||document.activeElement;
  resume=Boolean(window.MicasaSeasonal?.getState().playing);
  try{dialog.showModal()}catch{return}
  markSeen(dialog);bodyOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
  window.MicasaSeasonal?.pause();
  dialog.querySelector('[data-hero-promo-close]')?.focus({preventScroll:true});
 }
 dialogs.forEach(dialog=>{
  scope.on(dialog,'click',event=>{if(event.target.closest('[data-hero-promo-close]')||event.target===dialog)dialog.close()});
  scope.on(dialog,'close',restore);
 });
 scope.on(root,'click',event=>{
  const trigger=event.target.closest('[data-hero-promo-open]');if(!trigger)return;
  const dialog=dialogs.find(item=>item.dataset.heroPromoDialog===trigger.dataset.heroPromoOpen);
  if(dialog){event.preventDefault();open(dialog,trigger)}
 });
 const first=dialogs[0];
 function automatic(){
  if(!scope.active||seen(first)||window.MicasaConfig?.designMode)return;
  const busy=[...document.querySelectorAll('dialog[open],#shopify-pc__banner,#shopify-pc__prefs')].some(node=>node.getClientRects().length>0);
  if(document.visibilityState==='hidden'||busy){scope.timeout(automatic,1500);return}
  open(first);
 }
 if(!seen(first)&&!window.MicasaConfig?.designMode)scope.timeout(automatic,Math.max(500,Number(config.promotion_popup_delay)||1500));
 scope.defer(()=>{dialogs.forEach(dialog=>{if(dialog.open)dialog.close()});restore()});
});
